import { emsMediumGrey } from "@electricMotorShop/EmsVariables";
import { cartTotalDisplayStyles } from "@insite/content-library/Components/CartTotalDisplay";
import { cartLineCardCondensedStyles } from "@insite/content-library/Widgets/Cart/CartLineCardCondensed";
import { cartLineNotesStyles } from "@insite/content-library/Widgets/Cart/CartLineNotes";
import { cartLinesStyles } from "@insite/content-library/Widgets/Cart/CartLines";
import { cartTotalStyles } from "@insite/content-library/Widgets/Cart/CartTotal";
import { headerStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries, get } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

// CartTotal
cartTotalStyles.cancelPunchOutButton = {
    variant: "secondary",
    css: css`
        width: 100%;
        margin-top: 10px;
        position: inherit;
        left: inherit;
        bottom: inherit;
    `,
};
cartTotalStyles.submitQuoteButton = {
    variant: "secondary",
    css: css`
        width: 100%;
        margin-top: 10px;
        position: inherit;
        left: inherit;
        bottom: inherit;
    `,
};
cartTotalStyles.saveOrderButton = {
    variant: "secondary",
    css: css`
        width: 100%;
        margin-top: 10px;
        position: inherit;
        left: inherit;
        bottom: inherit;
    `,
};

cartTotalStyles.checkoutButton = {
     css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        position: fixed;
                        left: 20px;
                        right: 20px;
                        bottom: 50px;

                        height: 60px;
                        padding: 0;

                        /* perfect text centering */
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        
                        /* button appearance */
                        background-color: #cf1f25 !important;
                        border-radius: 10px !important;
                        z-index: ${get(theme, "zIndex.stickyFooter")};

                        /* keep original button colors/styles from theme */
                        box-sizing: border-box;
                    `,
                    css`
                        width: 100%;
                        margin-top: 10px;
                        position: inherit;
                        left: inherit;
                        bottom: inherit;
                        right: inherit;
                    `,
                ],
                "min",
            )}
    `,
};

// CartTotalDisplay
cartTotalDisplayStyles.container = {
    gap: 10,
    css: css`
        border-top: 1px solid ${emsMediumGrey};
        background: none;
        font-weight: bold;
        font-size: 24px;
        padding: 10px 0;
    `,
};

// CartLineCardCondensed
cartLineCardCondensedStyles.container = {
    gap: 20,
    css: css`
        border-bottom: 1px solid ${emsMediumGrey};
        padding: 1rem 0;
    `,
};

// CartLines
cartLinesStyles.headerWrapper = {
    css: css`
        border-bottom: 1px solid ${emsMediumGrey};
        padding-bottom: 10px;
    `,
};

// CartLineNotes
cartLineNotesStyles.wrapper = {
    css: css`
        width: 100%;
        padding: 0px;
    `,
};

cartLineNotesStyles.label = {
    css: css`
        button {
            color: ${getColor("secondary.contrast")};
            background: none;
            border: none;
            padding: 0px;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
        }
    `,
};

// Order Confirmation
// OrderConfirmationHeader
headerStyles.printButton = {
    variant: "secondary",
};

headerStyles.addToListButton = {
    variant: "secondary",
    css: css`
        margin-left: 10px;
    `,
};
